import { UntypedFormArray } from "@angular/forms";
import { createAction, props } from "@ngrx/store";
import { TransactionDirection, TransactionType } from "../../shared/types/Transaction";
import { TransactionForm } from "../models/form/TransactionForm";
import { DistributionReason } from "../models/internal-transfer/DistributionReason";
import { Acknowledgement } from "../models/review-page/ReviewPage";
import { DraftCommonWire } from "../models/wire/WireTemplatesResponse";

export const transactionFormLoaded = createAction(
    '[Create Request - Transaction Form] Transaction Form Loaded',
    props<{ transactionForm: UntypedFormArray }>()
);

export const continueClickInvalid = createAction(
    '[Create Request - Transaction Form] Continue clicked with form in invalid state'
);

export const transactionTypeChanged = createAction(
    '[Create Request - Transaction Form] Transaction type changed',
    props<{transactionType: TransactionType}>()
);

export const sloaSelectionChanged = createAction(
    '[Create Request - Transaction Form] SLOA selection changed'
)

export const saveTemplateSelectionChanged = createAction(
    '[Create Request - Transaction Form] Use saved template selection changed'
);

export const templatePrefilledFlowStarted = createAction(
    '[Create Request - Transaction Form] Template prefilled flow started',
    props<{response: DraftCommonWire, mapRecipientFromDraft: boolean}>()
)

export const templatePrefilledFlowComplete = createAction(
    '[Create Request - Transaction Form] Template prefilled flow completed',
)

export const updateFrequencyAch = createAction(
    '[Create Request - Transaction Form - ACH] Update Frequency',
    props<{ frequency: TransactionDirection }>()
);

export const updateFormValue = createAction(
    '[Create Request - Transaction Form] Update form value',
    props<Partial<TransactionForm>>()
);

export const resetTransactionForm = createAction(
    '[Create Request - Transaction Form] Reset Transaction Form to initial state',
    props<{transactionType: string}>()
);

export const updateFormStatus = createAction(
    '[Create Request - Transaction Form] Update to form status',
    props<{ valid: boolean }>()
);

export const TransactionTypeSelected = createAction(
    '[Create Request - Transaction Form] Transaction type selected'
);

export const callAchVerify = createAction(
    '[Create Request - Transaction Form] Call ach verify',
    props<TransactionForm>()
);

export const callAchAddProfileVerify = createAction(
    '[Create Request - Transaction Form] Call ach add profile verify',
    props<{transactionForm: TransactionForm, isInRViewReviewFlow?: boolean}>()
);

export const callInternalTransferVerify = createAction(
    '[Create Request - Transaction Form] Call internal transfer verify',
    props<{ transactionForm: TransactionForm, isInRViewReviewFlow: boolean }>()
);

export const callInternalTransferVerifyCustomRule = createAction(
    '[Create Request - Transaction Form] Call internal transfer verify create standing auth custom rules split transaction',
    props<{ transactionForm: TransactionForm}>()
);

export const continueClickTotalDist = createAction(
    '[Create Request - Transaction Form] Continue clicked with One Time Total Distribution frequency selected',
    props<{ transactionForm: TransactionForm }>() 
);

export const callInternalTransferListVerify = createAction(
    '[Create Request - Transaction Form] Call internal transfer list verify',
    props<{transactionForm: TransactionForm, isInRViewReviewFlow?: boolean}>()
);

export const loadInternalTransferWithoutVerifyCall = createAction(
  '[Create Request - Transaction Form] Load Internal Transfer Review page without calling verify endpoint',
  props<TransactionForm>()
);

export const callWiresVerifyV3 = createAction(
    '[Create Request - Transaction Form] Call wires verify v3 for ISO 20022',
    props<TransactionForm>()
);

export const callWireSloaVerifyV3FromCreateTransaction = createAction(
    '[Create Request - Transaction Form] Call wires verify v3 for OneTime And Sloa ISO 20022',
    props<TransactionForm>()
);

export const callWireSloaVerifyV3FromCreateTransactionCustomRulesSplit = createAction(
    '[Create Request - Transaction Form] Call wires verify v3 for OneTime And Sloa ISO 20022 Custom Rules Split',
    props<TransactionForm>()
);

export const callOnetimeCheckVerify = createAction(
    '[Create Request - Transaction Form] Call onetime check verify',
    props<TransactionForm>()
);

export const callRecurringCheckVerify = createAction(
    '[Create Request - Transaction Form] Call recurring check verify',
    props<TransactionForm>()
);

export const loadChecksReviewPageWithoutVerifyCall = createAction(
  '[Create Request - Transaction Form] Load Check Review page without calling verify endpoint',
  props<TransactionForm>()
);

export const cancelClicked = createAction(
    '[Create Request - Transaction Form] Cancel clicked'
);

export const updateAcknowledgement = createAction(
    '[Create Request - Internal Transfer] Update acknowledgement',
    props<{ acknowledgement: Acknowledgement }>()
);

export const editLoading = createAction(
    '[Create Request - Transaction Form] Edit loading - no API call made'
);

export const editLoadComplete = createAction(
    '[Create Request - Transaction Form] Edit loading completed'
);

export const editLoadCompleteForEditPage = createAction(
    '[Edit Transaction- Transaction Form] Edit loading completed for Edit transaction page'
);

export const initializeServiceError = createAction(
    '[Create Request - Transaction Form] Transaction Form service error initialized'
)

export const distributionReasonChanged = createAction(
    '[Create Request - Transaction Form] Update selected distribution reason',
    props<{ distributionReason: DistributionReason, transactionType: TransactionType | '' }>()
);

export const distributionReasonChangedMultipleIT = createAction(
    '[Create Request - Transaction Form] Update selected distribution reason for multiple internal transfers',
);

export const loadReviewPage = createAction(
    '[Create Request - Transaction Form] Load Review page'
);

export const accountEmpty = createAction(
    '[Create Request - Transaction Form] Account empty - no API call made'
);
